
class ParkMachineSerializer {

    static serialize (formFields) {
        return {
            categoryId: formFields.categoryId,
            brand: formFields.brand,
            model: formFields.model,
            quantity: formFields.quantity,
            statusCode: formFields.statusCode,
            removeImage: formFields.removeImage
        };
    }

    static deserialize(parkMachine) {
        return {
            companyId: parkMachine.company.id,
            companyName: parkMachine.company.name,
            categoryId: parkMachine.category.id,
            categoryName: parkMachine.category.name,
            brand: parkMachine.brand,
            model: parkMachine.model,
            quantity: parkMachine.quantity,
            statusCode: parkMachine.statusCode,
            photo: parkMachine.photo
        };
    }
}

export default ParkMachineSerializer;


// WEBPACK FOOTER //
// ./web/src/services/park-machine/ParkMachineSerializer.js